import { useState, useEffect } from "react";
import { useCall } from "@usedapp/core";
import { Contract } from "@ethersproject/contracts";
import AirdropFactory from "@/chain-info/contracts/AirdropFactory.json";
import NFTAirdropFactory from "@/chain-info/contracts/NFTAirdropFactory.json";
import { constants, utils } from "ethers";
import networkMapping from "@/chain-info/map.json";

const useAllCampaignsByType = (
  campaignType: string,
  chainId: number | undefined
) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | undefined>();
  const [campaigns, setCampaigns] = useState<any[]>([]);

  const { abi: TokenAbi } = AirdropFactory;
  let stringChainId = String(chainId);
  const airdropFactoryAddress = chainId
    ? (networkMapping as any)[stringChainId]["AirdropFactory"][0]
    : constants.AddressZero;
  const airdropFactoryInterface = new utils.Interface(TokenAbi);
  const airdropFactoryContract = new Contract(
    airdropFactoryAddress,
    airdropFactoryInterface
  );

  const { abi: NFTAbi } = NFTAirdropFactory;
  const nftAirdropFactoryAddress = chainId
    ? (networkMapping as any)[stringChainId]["NFTAirdropFactory"][0]
    : constants.AddressZero;
  const nftAirdropFactoryInterface = new utils.Interface(NFTAbi);
  const nftAirdropFactoryContract = new Contract(
    nftAirdropFactoryAddress,
    nftAirdropFactoryInterface
  );

  const contract =
    campaignType === "TOKEN"
      ? airdropFactoryContract
      : nftAirdropFactoryContract;
  const { value, error: callError } =
    useCall(
      {
        contract: contract as any,
        method: "getAllCampaigns",
        args: [],
      },
      { chainId: chainId }
    ) ?? {};
  if (callError) {
    console.error(callError.message);
  }

  useEffect(() => {
    setLoading(true);
    if (value) {
      setCampaigns(value?.[0]);
      setLoading(false);
    }
    if (callError) {
      setError(callError.message);
      setLoading(false);
    }
  }, [callError, value]);

  return { campaigns, error, loading };
};

export default useAllCampaignsByType;
